const routes = {
    aboutLogin: '/about-login',
    accessibilityStatement: '/accessibility-statement',
    adminPanel: '/admin-panel',
    analytics: '/analytics',
    contact: '/contact',
    dashboard: '/dashboard',
    gdprPrivacyNote: '/gdpr-privacy-note',
    help: '/help',
    home: '/',
    importantLinks: '/important-links',
    login: '/login',
    news: '/news',
    privacyPolicy: '/privacy-policy',
    record: '/:type/:id',
    search: '/search',
    termsAndConditions: '/terms-and-conditions',
    termsOfUse: '/terms-of-use',
    upload: '/upload',
    user: '/user',
}

export default routes
